import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  clearPosts,
  setInstagramAccountCredentials,
} from "../Store/instagramSlice";

function useInstagramIntegrationHook(username) {
  const { integrations } = useSelector((state) => state.user.integrations);
  const instaIntegration = integrations?.find(
    (item) => item.id === "instagram_connect"
  );
  const dispatch = useDispatch();

  const handleSetSelectedAccountCredentials = (username) => {
    if (!Array.isArray(instaIntegration?.credentials)) return;
    const credentials = instaIntegration.credentials?.find(
      (credential) => credential.username === username
    );
    dispatch(setInstagramAccountCredentials(credentials));
    dispatch(clearPosts());
  };

  useEffect(() => {
    if (username) handleSetSelectedAccountCredentials(username);
  }, []);

  return {
    handleSetSelectedAccountCredentials,
    accounts: instaIntegration?.credentials || [],
  };
}

export default useInstagramIntegrationHook;
